export const routes = {
  home: "/",
  //joinWaitList: "/join-waitlist",
  //joinWaitListThanks: "/join-waitlist-thanks",
  //JoinWaitListApprove: "/join-waitlist-approve",
  //login: '/login',
  //forgotPassword: '/forgot-password'
};
